import React from 'react';
import './BadgeItem.css';

export const BADGE_TYPES: Record<number, { label: string; className: string }> = {
  0: { label: 'Sport', className: 'badge-type-sport' },
  1: { label: 'City', className: 'badge-type-city' },
  2: { label: 'Holiday', className: 'badge-type-holiday' },
  3: { label: 'Travel', className: 'badge-type-travel' },
  4: { label: 'Meetup', className: 'badge-type-meetup' },
};

interface BadgeItemProps {
  name: string;
  type?: number;
  actionLabel?: string;
  onAction?: () => void;
}

const BadgeItem: React.FC<BadgeItemProps> = ({ name, type, actionLabel = '×', onAction }) => {
  return (
    <div className={`badge-item ${type !== undefined ? BADGE_TYPES[type]?.className || '' : ''}`}>
      <span className="badge-name">{name}</span>
      {onAction && (
        <button className="badge-action" onClick={onAction}>{actionLabel}</button>
      )}
    </div>
  );
};

export default BadgeItem;